export const removeTimeFromDate = (dateString) => {
  return dateString?.split("T")?.[0];
};
